import { createApp } from 'vue'
import App from './App.vue'
import BiliData from './components/BiliData.vue'


createApp(App).mount('#app')
createApp(BiliData).mount('#bz-data')
